import { differenceInDays as p } from "date-fns";
const m = (f, r, o) => (f && r && p(r, f) > o && (f = new Date(r.getTime() - o * 24 * 60 * 60 * 1e3)), [f, r]);
export {
  m as applyMaxInterval
};
